import { Link } from 'react-router-dom';
import { ChevronRight, MessageCircle, Zap, Users } from 'lucide-react';
import { BRAND_CONTACT } from '@/config/brand';
import { trackWhatsAppClick } from '@/lib/crm/track';
import { Reveal, Eyebrow, H2 } from './shared';

export const HOME_FAQ = [
  {
    q: 'Qual o melhor hidratante para pele ressecada e sensível?',
    a: 'Um hidratante sem perfume, com toque seco e testado em pele sensível. O Hidratante Corporal NAT HOF não leva perfume nem parabenos, foi testado em HRIPT por laboratório independente e absorve rápido, sem pesar no calor.',
  },
  {
    q: 'Hidratante sem cheiro é melhor para pele sensível?',
    a: 'Sim. Perfume é a causa mais comum de irritação de contato, por isso os hidratantes NAT HOF para corpo, mãos e pés não têm perfume. O Bálsamo é a exceção: leva óleos essenciais de lavanda e palma-rosa.',
  },
  {
    q: 'O que passar nos pés rachados?',
    a: 'Um creme para pés com manteiga de karité e alantoína, depois do banho, nos pés limpos e secos, todos os dias. O Hidratante para os Pés NAT HOF tem toque seco: dá para calçar logo em seguida.',
  },
  {
    q: 'Qual creme para mãos ressecadas de tanto lavar?',
    a: 'Um creme para mãos de toque seco, que você consiga reaplicar várias vezes ao dia. O Hidratante para as Mãos NAT HOF leva karité, própolis e aloe vera, sem perfume e sem deixar a mão escorregando.',
  },
  {
    q: 'Qual hidratante usar na pele de idoso?',
    a: 'Um hidratante corporal sem perfume, aplicado depois do banho. O pote de 1kg com válvula pump facilita o uso com uma mão só.',
  },
  {
    q: 'Que teste os produtos NAT HOF fizeram?',
    a: 'Teste de contato repetido (HRIPT) em laboratório independente, com voluntários. Todos são cosméticos notificados na ANVISA, com número de processo no rótulo.',
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: HOME_FAQ.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export const WhatsAppFaq = () => {
  const waHref = `https://wa.me/${BRAND_CONTACT.whatsappInternational}`;
  return (
    <section className="bg-v2-bg text-v2-ink py-16 md:py-24">
      <Reveal className="container mx-auto px-5 max-w-6xl">
        <Eyebrow>Atendimento</Eyebrow>
        <H2 className="max-w-2xl">Ficou em dúvida? Fale com gente de verdade.</H2>
        <p className="mt-4 max-w-xl text-v2-muted">
          Responde na hora e, se precisar, chama uma pessoa da equipe.{' '}
          <Link to="/garantia" className="underline underline-offset-4 font-medium">Não gostou? Devolvemos 100% em 7 dias.</Link>
        </p>
        <div className="mt-8 grid sm:grid-cols-2 gap-3">
          <div className="rounded-2xl bg-background border border-v2-ink/10 p-5">
            <Zap className="w-5 h-5 text-v2-blue mb-3" />
            <p className="font-semibold">Resposta na hora</p>
            <p className="text-base text-v2-muted mt-1">Nossa assistente tira dúvida de produto, uso e frete, 24h.</p>
          </div>
          <div className="rounded-2xl bg-background border border-v2-ink/10 p-5">
            <Users className="w-5 h-5 text-v2-blue mb-3" />
            <p className="font-semibold">Gente de verdade</p>
            <p className="text-base text-v2-muted mt-1">Caso mais delicado? Passa para a equipe NAT HOF no mesmo chat.</p>
          </div>
        </div>
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick('home_v2_faq', BRAND_CONTACT.whatsappInternational)}
          className="mt-6 inline-flex items-center justify-center gap-2 min-h-12 px-6 rounded-full bg-v2-bal text-background font-semibold hover:bg-v2-bal/90"
        >
          <MessageCircle className="w-4 h-4" /> Falar no WhatsApp
        </a>

        <div className="mt-14 max-w-3xl">
          <h3 className="font-narrow text-2xl md:text-3xl font-semibold mb-5">Perguntas frequentes</h3>
          <div className="space-y-3">
            {HOME_FAQ.map((f) => (
              <details key={f.q} className="group bg-background border border-v2-ink/10 rounded-xl overflow-hidden">
                <summary className="flex items-center justify-between gap-3 p-4 cursor-pointer list-none font-medium">
                  {f.q}
                  <ChevronRight className="w-5 h-5 shrink-0 opacity-60 transition-transform group-open:rotate-90" />
                </summary>
                <div className="px-4 pb-4 text-base text-v2-muted">{f.a}</div>
              </details>
            ))}
          </div>
          <Link to="/faq" className="mt-6 inline-flex items-center gap-1 font-medium underline underline-offset-4">
            Ver todas as perguntas <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </Reveal>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
    </section>
  );
};
